import(/* webpackMode: "eager" */ "/home/forge/sdd-marburg-app.schleegleixner.dev/node_modules/next/dist/client/app-dir/link.js");
